
(function() {

    'use strict';
   
    var ItxBundleCarrouselCmp = {
        bindings: {
            product: '<',
            arrayProducts: '<',
            layout: '<',
            inViewport:'<',
            slidesPerView: '<',
            onProductClick: '&',
            place: '<'
        },
        controller: ItxBundleCarrouselCtrl,
        templateUrl: 'bundle-carrousel.component.html'
    };

    angular.module('itxApp.common')
        .component('itxBundleCarrousel', ItxBundleCarrouselCmp);

    ItxBundleCarrouselCtrl.$inject = [
        'ItxConstants',
        'Product',
        'ItxUtilsFct'
    ];

    function ItxBundleCarrouselCtrl(
        ItxConstants,
        Product,
        ItxUtilsFct
    ){

        var _this = this;
        

        _this.$onInit = () => {
            
            _this.isColors = _this.product.state.conf.typeCarrousel.isColors;
            _this.isLook = _this.product.state.conf.typeCarrousel.isLook;

            if(_this.isColors){
                _this.bundleProduct = angular.copy(new Product(_this.product.bundleProductSummaries[0]));
                _this.bundleProduct.config = {
                    isNoRollover : true
                };
            } else {
                _this.bundleProduct = angular.copy(_this.product);
            }
            _this.bundleCarrousel = angular.copy(_this.product);
            
            var newConf = {};
            
            if(_this.isColors || _this.isLook){
                newConf.pricesBundle = false;
                newConf.moreColors = false;
            }
            newConf.hasNameButton = _this.product.name? _this.product.name : false;
            newConf.detailButton = !_this.isColors;
            
            _this.bundleCarrousel.state.conf = _.extend(_this.bundleCarrousel.state.conf,newConf);
            _this.bundleProduct.state.conf = _.extend(_this.bundleProduct.state.conf,newConf);

            if(_this.isColors){
                _this.bundleCarrousel = _getProductDetailColors(_this.bundleCarrousel);
            }

            var hideDetailsProducts = _this.isColors || _this.isLook;
            _this.arrayProducts.forEach(product=>{
                if(hideDetailsProducts){
                    product.state.conf.details = false;
                }
                product.state.locationImgCarrousel = _setLocImg(product);
            });    
            
        };

        _this.$onChanges = (changes) => {

        };
        
        function _setLocImg(product) {
            // BUNDLE_CARROUSEL_COLORS - Si no existe imagen en el location 5, cogemos location 4
            // BUNDLE_CARROUSEL_LOOK && BUNDLE_CARROUSEL - Si no existe imagen en el location 5, cogemos location 1
            // place related - location 4
            let locationProductPage = !_this.isColors;
            let locationSize = 'relatedProduct'; // location 4
            if(_this.place == 'category'){
                var XmedLocBun = ItxConstants.xmediaLocations['bundleComponent']; 
                var xmediaImages = ItxUtilsFct.getProductXmediaImagesData(product, XmedLocBun, 500);
                if(xmediaImages.length > 0){
                    locationSize = 'bundleComponent'; // location 5 
                } else {
                    if(locationProductPage){
                        locationSize = 'productPage'; // location 1
                    }
                }
            }
            
            return locationSize;
        }

        function _getProductDetailColors(p) {
            let newProduct;
            if(p.bundleProductSummaries.length > 0){
                newProduct = new Product(p.bundleProductSummaries[0]);
                newProduct.state.conf.moreColors = false;
            } 
            if(newProduct.gridElemType == "MOCACO"){
                _this.selectedColor = newProduct.bundleProductSummaries[0].detail.colors[0];
            } else {
                _this.selectedColor = newProduct.detail.colors[0];
            }
            return newProduct;
        };

    }

})();